import { call, put, takeLatest } from 'redux-saga/effects';
import User from '../../api/user';
import { actionTypes, getUsersSuccess } from '../actions/user';

function* getUsers(action) {
  try {
    const result = yield call(() => User.getUsers(action.payload));
    yield put(getUsersSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* createUser(action) {
  try {
    const result = yield call(() => User.createUser(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* getUser(action) {
  try {
    const result = yield call(() => User.getUser(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* updateUser(action) {
  try {
    const result = yield call(() => User.updateUser(action.payload.id, action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

export default function* userSaga() {
  yield takeLatest(actionTypes.GET_USERS, getUsers);
  yield takeLatest(actionTypes.CREATE_USER, createUser);
  yield takeLatest(actionTypes.GET_USER_BY_ID, getUser);
  yield takeLatest(actionTypes.UPDATE_USER, updateUser);
}
